/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FieldPlacement
 */
export interface FieldPlacement {
    /**
     * Unique identifier for the field placement
     * @type {string}
     * @memberof FieldPlacement
     */
    id: string;
    /**
     * Key to map to claim data (e.g., 'insured_name', 'date_of_loss')
     * @type {string}
     * @memberof FieldPlacement
     */
    fieldKey: string;
    /**
     * Display label for the field
     * @type {string}
     * @memberof FieldPlacement
     */
    label: string;
    /**
     * Field type (data=pre-filled, text_input=user enters, signature=signature pad, static_text=adjuster-authored text, adjuster_signature=adjuster's own signature)
     * @type {string}
     * @memberof FieldPlacement
     */
    type: FieldPlacementTypeEnum;
    /**
     * Page number (0-based)
     * @type {number}
     * @memberof FieldPlacement
     */
    page: number;
    /**
     * X position as percentage of page width
     * @type {number}
     * @memberof FieldPlacement
     */
    x: number;
    /**
     * Y position as percentage of page height
     * @type {number}
     * @memberof FieldPlacement
     */
    y: number;
    /**
     * Width as percentage of page width
     * @type {number}
     * @memberof FieldPlacement
     */
    width: number;
    /**
     * Height as percentage of page height
     * @type {number}
     * @memberof FieldPlacement
     */
    height: number;
    /**
     * Font size for text
     * @type {number}
     * @memberof FieldPlacement
     */
    fontSize: number;
    /**
     * Font family name
     * @type {string}
     * @memberof FieldPlacement
     */
    fontFamily: string;
    /**
     * Text alignment
     * @type {string}
     * @memberof FieldPlacement
     */
    textAlign: FieldPlacementTextAlignEnum;
    /**
     * Whether the field is required
     * @type {boolean}
     * @memberof FieldPlacement
     */
    required?: boolean;
    /**
     * Whether user-entered text wraps across multiple lines (true) or stays on a single shrink-to-fit line (false)
     * @type {boolean}
     * @memberof FieldPlacement
     */
    multiline?: boolean;
    /**
     * Static content authored by the adjuster (for static_text and adjuster_signature fields)
     * @type {string}
     * @memberof FieldPlacement
     */
    staticContent?: string;
}


/**
 * @export
 */
export const FieldPlacementTypeEnum = {
    Data: 'data',
    TextInput: 'text_input',
    Signature: 'signature',
    StaticText: 'static_text',
    AdjusterSignature: 'adjuster_signature'
} as const;
export type FieldPlacementTypeEnum = typeof FieldPlacementTypeEnum[keyof typeof FieldPlacementTypeEnum];

/**
 * @export
 */
export const FieldPlacementTextAlignEnum = {
    Left: 'left',
    Center: 'center',
    Right: 'right'
} as const;
export type FieldPlacementTextAlignEnum = typeof FieldPlacementTextAlignEnum[keyof typeof FieldPlacementTextAlignEnum];


/**
 * Check if a given object implements the FieldPlacement interface.
 */
export function instanceOfFieldPlacement(value: object): value is FieldPlacement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fieldKey' in value) || value['fieldKey'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('fontSize' in value) || value['fontSize'] === undefined) return false;
    if (!('fontFamily' in value) || value['fontFamily'] === undefined) return false;
    if (!('textAlign' in value) || value['textAlign'] === undefined) return false;
    return true;
}

export function FieldPlacementFromJSON(json: any): FieldPlacement {
    return FieldPlacementFromJSONTyped(json, false);
}

export function FieldPlacementFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldPlacement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fieldKey': json['fieldKey'],
        'label': json['label'],
        'type': json['type'],
        'page': json['page'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'],
        'height': json['height'],
        'fontSize': json['fontSize'],
        'fontFamily': json['fontFamily'],
        'textAlign': json['textAlign'],
        'required': json['required'] == null ? undefined : json['required'],
        'multiline': json['multiline'] == null ? undefined : json['multiline'],
        'staticContent': json['staticContent'] == null ? undefined : json['staticContent'],
    };
}

export function FieldPlacementToJSON(json: any): FieldPlacement {
    return FieldPlacementToJSONTyped(json, false);
}

export function FieldPlacementToJSONTyped(value?: FieldPlacement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'fieldKey': value['fieldKey'],
        'label': value['label'],
        'type': value['type'],
        'page': value['page'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
        'fontSize': value['fontSize'],
        'fontFamily': value['fontFamily'],
        'textAlign': value['textAlign'],
        'required': value['required'],
        'multiline': value['multiline'],
        'staticContent': value['staticContent'],
    };
}

